import {
  Button,
  CardContent,
  Grid,
  TextField,
  Typography,
  Divider,
} from "@mui/material";
import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
import React, { useState, useEffect } from "react";
import axios from "axios";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import HOST_URL from "../../../utils/Url";
import Autocomplete from "@mui/material/Autocomplete";
import { useTranslation } from "react-i18next";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import ToastApp from "../../../ToastApp";
import { CircularProgress } from "@mui/material";
import { useRef } from "react";

type Props = {};

const StateMasterEdit = (props: Props) => {
  const location = useLocation();
  console.log("location", location.state);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const submitTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  let navigate = useNavigate();
  const { t } = useTranslation();
  const [toaster, setToaster] = useState(false);
  const [option, setOption] = useState([
    { value: "-1", label: "Select Country Name" },
  ]);

  useEffect(() => {
    getCountryName();
  }, [])

  const getCountryName = () => {
    const collectData = {
      "country_id": -1,
      "user_id": "",
      "inst_ID": -1
    };
    axios
      .post(HOST_URL.HOST_URL2 + `Country/GetCountryMaster`, collectData)
      .then((res) => {
        const arr = [];
        //console.log("result" + JSON.stringify(res.data.data));
        for (let index = 0; index < res.data.data.length; index++) {
          arr.push({
            label: res.data.data[index]["country_name"],
            value: res.data.data[index]["country_id"],
          });
        }
        setOption(arr);
      });
  };


  const validationSchema = Yup.object({
    country_id: Yup.string().test(
      "required",
      t("text.reqcountryName"),
      function (value: any) {
        return value && value.trim() !== "";
      }
    ),
    state_name: Yup.string()
      .matches(/^[A-Za-z0-9\s]+$/, t("text.noSpecialChars")) // allow only letters, numbers, spaces
      .test("required", t("text.reqstateName"), function (value: any) {
        return value && value.trim() !== "";
      }),
    state_shortname: Yup.string()
      .matches(/^[A-Za-z0-9]+$/, t("text.noSpecialChars")) // only letters & numbers
  });


  const formik = useFormik({
    initialValues: {
      state_id: location.state.state_id,
      state_name: location.state.state_name,
      state_shortname: location.state.state_shortname,
      country_id: location.state.country_id,
      countryName: location.state.countryName,
      user_id: location.state.user_id,
      inst_ID: location.state.inst_ID,
      allowedto: location.state.allowedto,

    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      // Clear any existing timeout
      if (submitTimeoutRef.current) {
        clearTimeout(submitTimeoutRef.current);
      }

      // If already submitting, show message and return
      if (isSubmitting) {
        toast.info(t("text.requestInProgress"));
        return;
      }

      setIsSubmitting(true);

      try {
        const response = await axios.post(
          HOST_URL.HOST_URL2 + `State/AddUpdateStateMaster`,
          values
        );

        if (response.data.isSuccess) {
          setToaster(false);
          toast.success(response.data.mesg);
          navigate("/master/StateMaster");
        } else {
          setToaster(true);
          toast.error(response.data.mesg);
        }
      } catch (error: any) {
        if (error.response && error.response.status === 429) {
          toast.error(t("text.tooManyRequests"));
        } else {
          toast.error(t("text.somethingWentWrong"));
        }
        setToaster(true);
      } finally {
        // Set a timeout to reset isSubmitting after 2 seconds
        submitTimeoutRef.current = setTimeout(() => {
          setIsSubmitting(false);
        }, 2000);
      }
    },
  });
  // Add cleanup effect after the formik declaration
  React.useEffect(() => {
    return () => {
      if (submitTimeoutRef.current) {
        clearTimeout(submitTimeoutRef.current);
      }
    };
  }, []);
  const requiredFields = ["state_name", "country_id"];

  const back = useNavigate();
  return (
    <div>
      <div
        style={{
          padding: "-5px 5px",
          backgroundColor: "#ffffff",
          borderRadius: "5px",
          marginTop: "5px",
          border: ".5px solid #FF7722",
        }}
      >
        <CardContent>
          <Typography
            variant="h5"
            textAlign="center"
            style={{ fontSize: "18px", fontWeight: 500 }}
          >
            {t("text.EditStateMaster")}
          </Typography>

          <Grid item sm={4} xs={12}>
            <Typography style={{ marginTop: "-75px" }}>
              <Button
                type="button"
                onClick={() => back(-1)}
                variant="contained"
                style={{
                  marginBottom: 15,
                  marginTop: "45px",
                  backgroundColor: `var(--header-background)`,
                  width: 20,
                }}
                disabled={isSubmitting}
              >
                <ArrowBackSharpIcon />
              </Button>
            </Typography>
          </Grid>
          <Divider />
          <br />
          <form onSubmit={formik.handleSubmit}>
            {toaster === false ? "" : <ToastApp />}
            <Grid item xs={12} container spacing={2}>
              <Grid xs={12} sm={4} item>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={option}
                  disabled={isSubmitting}
                  value={
                    option.find(
                      (option) => option.value === formik.values.country_id
                    ) || null
                  }
                  fullWidth
                  size="small"
                  onChange={(event, newValue: any) => {
                    console.log(newValue?.value);

                    formik.setFieldValue("country_id", newValue?.value);

                    formik.setFieldTouched("country_id", true);
                    formik.setFieldTouched("country_id", false);
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label={
                      <span>
                        {t("text.SelectCountryName")} {""}
                        {requiredFields.includes('country_id') && (
                          <span style={{ color: formik.values.country_id ? 'green' : 'red' }}>*</span>
                        )}
                      </span>
                    } />
                  )}
                />

                {formik.touched.country_id && formik.errors.country_id ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {String(formik.errors.country_id)}
                  </div>
                ) : null}
              </Grid>

              <Grid md={4} item>
                <TextField
                  label={
                    <span>
                      {t("text.EnterStateName")}{" "}
                      {requiredFields.includes("state_name") && (
                        <span
                          style={{
                            color: formik.values.state_name ? "green" : "red",
                          }}
                        >
                          *
                        </span>
                      )}
                    </span>
                  }
                  value={formik.values.state_name}
                  name="state_name"
                  id="state_name"
                  placeholder={t("text.EnterStateName")}
                  size="small"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                  // Only allow letters and spaces
                  onChange={(e) => {
                    const regex = /^[A-Za-z\s]*$/;
                    if (regex.test(e.target.value)) {
                      formik.setFieldValue("state_name", e.target.value);
                    }
                  }}
                  onBlur={formik.handleBlur}
                  disabled={isSubmitting}
                  inputProps={{ maxLength: 30 }}
                />

                {formik.touched.state_name && formik.errors.state_name ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {String(formik.errors.state_name)}
                  </div>
                ) : null}
              </Grid>

              <Grid md={4} item>

                <TextField
                  label="Enter State Short Name"
                  value={formik.values.state_shortname}
                  name="state_shortname"
                  id="state_shortname"
                  placeholder="Enter State Short Name"
                  size="small"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                  // Allow only alphabets (no spaces if you want short form strict)
                  onChange={(e) => {
                    const regex = /^[A-Za-z]*$/;
                    if (regex.test(e.target.value)) {
                      formik.setFieldValue("state_shortname", e.target.value);
                    }
                  }}
                  onBlur={formik.handleBlur}
                  disabled={isSubmitting}
                  inputProps={{ maxLength: 10 }}
                />

              </Grid>

              <Grid item lg={6} sm={6} xs={12}>
                <Grid>
                  <Button
                    type="submit"
                    fullWidth
                    style={{
                      backgroundColor: `var(--header-background)`,
                      color: "white",
                      marginTop: "10px",
                    }}
                    disabled={isSubmitting}
                    startIcon={isSubmitting ? <CircularProgress size={16} color="inherit" /> : null}
                  >
                    {isSubmitting ? t("text.submitting") : t("text.update")}
                  </Button>
                </Grid>
              </Grid>
              <Grid item lg={6} sm={6} xs={12}>
                <Button
                  type="reset"
                  fullWidth
                  style={{
                    backgroundColor: "#F43F5E",
                    color: "white",
                    marginTop: "10px",
                  }}
                  disabled={isSubmitting}
                  onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                    formik.resetForm();
                  }}
                >
                  {t("text.reset")}
                </Button>
              </Grid>
            </Grid>
          </form>
        </CardContent>
      </div>
    </div>
  );
};

export default StateMasterEdit;
